<template lang="pug">
  .columnMappings
    //- User mappings first
    .row(v-for="(userMapping, index) in userMappings").mt-4
        .col-12
          SingleColMappingComponent(:mapping="userMapping", :index="index", :syncDirection="syncDirection", :columnMappings="columnMappings", @delete-user-mapping="removeUserMapping" :ref="'user_mapping_' + index")
          hr.mt-5
    //- New mapping
    .row.mt-4
        .col-12 
          button(@click="addNewMappingToUserMappings()").customButtonLinear.btn.primary-bg + Add fields
</template>

<script>
import {Validation} from '@/helpers'
import {InputComponent, SingleColMappingComponent} from './../'
import _ from 'lodash'

export default {
  name: 'ColumnMappings',
  props:{
    columnMappings: Array, 
    userMappings: Array,
    syncDirection: String
  },
  components: {
      InputComponent,
      SingleColMappingComponent
  },
  data() {
    return {
      showNewMapping: false,
      newMappingCode: null
    }
  },
  mounted() {
  },
  methods: {
    addNewMappingToUserMappings() {
      // JSON Parse for deep copying object by value (including objects inside object!)
      const newMapping = _.cloneDeep(this.columnMappings[0])
      newMapping.rules = [];
      this.userMappings.push(newMapping)
    },
    removeUserMapping(index){
      this.userMappings.splice(index, 1);
    },
    validate(){
      return Validation.validateFromRefs(this.$refs)
    }
  },
  computed: {
      newMapping: function () {
          return _.cloneDeep(this.columnMappings.find(x => x.code == this.newMappingCode))
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less'); 
   .nav-tabs {
       a {
           color: #4a4a4a;
       }
       .active {
           color: @primary !important;
       }
   }
   .title {
       font-weight: bold;
   }
</style>
